import {
  Component,
  computed,
  DestroyRef,
  inject,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import { startWith } from 'rxjs';

import { LocationsDataFacade } from '@core/locations-logic';
import { SelectComponent, SelectOption } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-locations-select-container',
  imports: [ReactiveFormsModule, SelectComponent],
  templateUrl: './locations-select-container.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './locations-select-container.component.less',
})
export class LocationsSelectContainerComponent {
  private readonly locationsDataFacade = inject(LocationsDataFacade);
  private readonly destroyRef = inject(DestroyRef);

  public control = input.required<FormControl<number>>();
  public isInvalid = input<boolean>(false);
  public isReadOnly = input<boolean>(false);

  public selectedOptions = output<SelectOption[]>();

  public allLocations = this.locationsDataFacade.allLocations;

  public locationOptions = computed(() =>
    this.allLocations().map(location => ({
      label: location.name,
      value: location.id,
    })),
  );

  protected ngOnInit(): void {
    this.control()
      .valueChanges.pipe(startWith(this.control().value), takeUntilDestroyed(this.destroyRef))
      .subscribe(value => {
        const selectedOption = this.allLocations().find(location => location.id === value);
        this.selectedOptions.emit(
          selectedOption
            ? [
                {
                  value: selectedOption.id,
                  label: selectedOption.name,
                },
              ]
            : [],
        );
      });
  }
}
